import BreakUpItem from '@/src/components/FareBreakup/BreakupItem'
import { BreakupListProps } from '@/src/types/FareBreakup'
import React from 'react'

const BreakupList: React.FC<BreakupListProps> = ({
    cfw,
    perPaxPricing,
    travellerCallout,
    pricingElements = [],
    showHeader = false,
    formatCurrency
}) => {
    const isDiscountArray = ['CB', 'DIS', 'SC']
    return (
        <>
            {pricingElements?.map?.((priceEle, index) => {
                const { displayText, amount, pricingCategory = '', type, strikeOffDetails } = priceEle
                return (
                    <BreakUpItem
                        cfw={cfw}
                        perPaxPricing={perPaxPricing}
                        travellerCallout={travellerCallout}
                        key={`fare-breakup-${index}`}
                        title={displayText}
                        price={amount}
                        isDiscount={isDiscountArray.includes(pricingCategory!)}
                        isSuperCoin={type === 'SUPERCOINS'}
                        strikeOffDetails={strikeOffDetails}
                        isTotalItem={index === pricingElements.length - 1}
                        formatCurrency={formatCurrency}
                    />
                )
            })}
        </>
    )
}

export default BreakupList
